import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { HipaaConsentAuthorizationComponent } from './components/hipaa-consent-authorization/hipaa-consent-authorization.component';
import { HomeComponent } from './components/home/home.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';
import { TermsOfTelemedicineComponent } from './components/terms-of-telemedicine/terms-of-telemedicine.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { TeliHealthComponent } from './components/teli-health/teli-health.component';
import { SharedModule } from './shared/shared.module';
import { NgxMaskOptions, NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { provideUserIdleConfig } from 'angular-user-idle';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbAccordionModule, NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

const maskConfig: NgxMaskOptions = {
  validation: false,
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContactUsComponent,
    HipaaConsentAuthorizationComponent,
    HomeComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    TermsOfTelemedicineComponent,
    TermsOfUseComponent,
    FeedbackComponent,
    TeliHealthComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgbAccordionModule,
    NgbCollapseModule,
    NgbModule,
    // AgmCoreModule?.forRoot({
    //   apiKey: environment?.agmApiKey,
    //   libraries: ['places']
    // }),
    NgxMaskDirective,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    provideNgxMask(maskConfig),
    provideUserIdleConfig({ idle: 1800, timeout: 1800, ping: 0 })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
